import React from "react";
import { Instagram, Camera, FileImage, Video, Layout, Hash } from "lucide-react";
import ServiceDetailTemplate from "@/pages/ServiceDetailTemplate";

const config = {
  testidPrefix: "sm",
  serviceNumber: "04",
  eyebrow: "Design Réseaux Sociaux",
  title: "Design",
  titleAccent: "Réseaux Sociaux",
  subtitle:
    "Des visuels qui captent l'attention et font grandir votre présence en ligne.",
  paragraphs: [
    "Sur les réseaux sociaux, chaque visuel doit refléter votre identité tout en captant l'attention en quelques secondes.",
    "Chez <strong class='font-medium'>Brams Graphic</strong>, nous créons des publications, stories, bannières, carrousels et templates personnalisés pour Instagram, TikTok, Facebook, LinkedIn et toutes vos plateformes — pensés pour votre marque et votre audience.",
    "Chaque design est conçu sur mesure : lisible, cohérent, mémorable, et parfaitement adapté aux contraintes de chaque format.",
    "Que vous soyez une marque, un commerce, un restaurant ou un indépendant, nous vous aidons à construire une présence digitale forte et constante.",
  ],
  bullets: [
    { icon: Instagram, title: "Publications Instagram", desc: "Posts, carrousels et grilles harmonisées pour un feed cohérent." },
    { icon: Camera, title: "Stories & Reels", desc: "Templates dynamiques pour stories quotidiennes et formats verticaux." },
    { icon: Layout, title: "Carrousels", desc: "Carrousels éducatifs, promotionnels ou narratifs au design impactant." },
    { icon: FileImage, title: "Bannières & Couvertures", desc: "Visuels Facebook, LinkedIn, YouTube et autres plateformes." },
    { icon: Hash, title: "Templates personnalisés", desc: "Kits réutilisables pour publier rapidement sans casser la cohérence." },
    { icon: Video, title: "Visuels animés", desc: "Animations courtes et motion design adaptés aux formats sociaux." },
  ],
  realisations: [
    "Feeds Instagram complets",
    "Templates de stories",
    "Bannières LinkedIn / Facebook",
    "Carrousels éducatifs",
    "Couvertures YouTube",
    "Visuels promotionnels",
  ],
  mockupSrc:
    "https://customer-assets.emergentagent.com/job_brams-portfolio/artifacts/0dm28pfp_ChatGPT%20Image%2027%20juin%202026%2C%2000_58_42%20copie.jpg",
  mockupAlt: "Design Réseaux Sociaux — publications BSG",
  badges: [
    { k: "Cohérence", v: "Visuelle" },
    { k: "Formats", v: "Optimisés" },
    { k: "Engagement", v: "Renforcé" },
  ],
  ctaLabel: "Demander un devis",
  bottomLine: (
    <>
      Faisons grandir votre <span style={{ color: "#E11D2E" }}>présence digitale</span>.
    </>
  ),
};

export default function SocialMedia() {
  return <ServiceDetailTemplate config={config} />;
}
